import script from "./LeadsNotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsNotesModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadsNotesModal.vue?vue&type=style&index=0&id=5986986c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5986986c"]])

export default __exports__